/*! Copyright (c) 2010 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Version 1.2.3
 */

(function (factory) {
    factory(jQuery);
}(function ($) {

    $.fn.overlaps = function(selector, options) {
        options = $.extend({
            includeBaseLabelHeight: false
        }, options);
        return this.pushStack(filterOverlaps(this, selector && $(selector), options));
    };

    function filterOverlaps(collection1, collection2, options) {
        var dims1  = getDims(collection1, options),
            dims2  = !collection2 ? dims1 : getDims(collection2, options),
            stack  = [],
            index1 = 0,
            index2 = 0,
            length1 = dims1.length,
            length2 = !collection2 ? dims1.length : dims2.length;
	
        if (!collection2) { collection2 = collection1; }

		// Ratio was gathered for fit.js ->preview vs renders the same -> Cormier 21-22 AND actually rendering that out - Puppeteer appears to have slightly different rounding than live view
		var marginOfError = 0.1;
		if(options && options.ratio) {
			// This might need to be walked back - it goes from 0.1 hard coded to about 0.8 on my machine.  If we need to change it, we probably need to change from --font-render-hinting=none to medium on rendering and tests.  Didn't do that yet because I don't have a full grasp on the ramifications.
			marginOfError = options.ratio / 200;
			// console.log('marginOfError: ' + marginOfError + ' from a ratio of ' + options.ratio);
		}

        for (; index1 < length1; index1++) {
            for (index2 = 0; index2 < length2; index2++) {
                if (collection1[index1] === collection2[index2]) {
                    continue;
                } else if (checkOverlap(dims1[index1], dims2[index2], {
					marginOfError: marginOfError
				})) {
                    stack.push( (length1 > length2) ?
                        collection1[index1] :
                        collection2[index2]);
                }
            }
        }

        return $.unique(stack);
    }

    function getDims(elems, options) {
        var dims = [], i = 0, elem;

        while ((elem = elems[i++])) {
			if($.isArray(elem)) {
				dims.push(elem);
			} else {
				var rect;
				if(elem.checkOverlapBoundsAgainst) {
					rect = elem.checkOverlapBoundsAgainst.getBoundingClientRect();
				} else {
					rect = elem.getBoundingClientRect();
				}
				var computedStyle = window.getComputedStyle(elem);
				var borderWidth = parseFloat(computedStyle.borderLeftWidth.replace('px', ''));
				var doubleBorderWidth = borderWidth * 2;
				
				var top = rect.top + borderWidth;
				var left = rect.left + borderWidth;
				var width = rect.width - doubleBorderWidth;
				var height = rect.height - doubleBorderWidth;

				if(options.includeBaseLabelHeight && elem.baseLabelHeight) {
					height += elem.baseLabelHeight;
				}

				dims.push([
					top,
					left,
					width,
					height
				]);
			}
        }

        return dims;
    }

    function checkOverlap(dims1, dims2, options) {
        var x1 = dims1[1], y1 = dims1[0],
            w1 = dims1[2], h1 = dims1[3],
            x2 = dims2[1], y2 = dims2[0],
			w2 = dims2[2], h2 = dims2[3];
		// Adding 0.1 of wiggle room will PROBABLY be fine since production renders are generally bigger than normal browser windows AND usually text scales bigger as the ratio goes up
        return w1 > 0 && w2 > 0 && h1 > 0 && h2 > 0 && 
			(y2 + h2) > y1 &&
			(y1 + h1) > y2 &&
			((x2 + w2) > x1 || Math.abs((x2 + w2) - x1) < options.marginOfError) &&
			((x1 + w1) > x2 || Math.abs((x1 + w1) - x2) < options.marginOfError);
    }

}));
